import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-effecten',
  templateUrl: './spec-effecten.component.html',
  imports: [
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SpecTrialbalanceComponent,
    CommonModule
  ],
  styleUrls: ['./spec-effecten.component.css']
})
export class SpecEffectenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public securitiesCurrentFg = {} as FormGroup;
  public securitiesListedFg = {} as FormGroup;
  public securitiesNonListedFg = {} as FormGroup;
  public securitiesCurrentDisclosureFg = {} as FormGroup;
  public securitiesCurrentFairValueDisclosureFg = {} as FormGroup;
  public securitiesUnavailableCurrentDescriptionFg = {} as FormGroup;
  public securitiesNoLegalOwnershipDescriptionFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService,) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.securitiesCurrentFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.securitiesListedFg = this.jrDataService.createFormGroupBalanceItem();
    this.securitiesNonListedFg = this.jrDataService.createFormGroupBalanceItem();
    this.securitiesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.securitiesCurrentFairValueDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.securitiesUnavailableCurrentDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.securitiesNoLegalOwnershipDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const effecten = value.rapportage?.jaarrekeningen?.at(0)?.balans?.effecten;
    if (effecten) {
      this.securitiesCurrentFg.reset();

      if (effecten.securitiesCurrent) {
        this.securitiesCurrentFg.patchValue(effecten.securitiesCurrent, {emitEvent: false})
      }

      const uitsplitsing = effecten.effectenUitsplitsing;
      const tekstueel = effecten.effectenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.securitiesListed) {
          const subItem = uitsplitsing.securitiesListed;
          this.securitiesListedFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.securitiesListedFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.securitiesNonListed) {
          const subItem = uitsplitsing.securitiesNonListed;
          this.securitiesNonListedFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.securitiesNonListedFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.securitiesCurrentDisclosure) {
          this.securitiesCurrentDisclosureFg.patchValue(tekstueel.securitiesCurrentDisclosure);
        }
        if (tekstueel.securitiesCurrentFairValueDisclosure) {
          this.securitiesCurrentFairValueDisclosureFg.patchValue(tekstueel.securitiesCurrentFairValueDisclosure);
        }
        if (tekstueel.securitiesUnavailableCurrentDescription) {
          this.securitiesUnavailableCurrentDescriptionFg.patchValue(tekstueel.securitiesUnavailableCurrentDescription);
        }
        if (tekstueel.securitiesNoLegalOwnershipDescription) {
          this.securitiesNoLegalOwnershipDescriptionFg.patchValue(tekstueel.securitiesNoLegalOwnershipDescription);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    this.securitiesCurrentFg.updateValueAndValidity();
    this.securitiesListedFg.updateValueAndValidity();
    this.securitiesNonListedFg.updateValueAndValidity();
    this.securitiesCurrentDisclosureFg.updateValueAndValidity();
    this.securitiesCurrentFairValueDisclosureFg.updateValueAndValidity();
    this.securitiesUnavailableCurrentDescriptionFg.updateValueAndValidity();
    this.securitiesNoLegalOwnershipDescriptionFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          effecten: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.effecten,
            effectenUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.effecten?.effectenUitsplitsing,
              securitiesListed: this.securitiesListedFg.value,
              securitiesNonListed: this.securitiesNonListedFg.value,
            },
            effectenTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.effecten?.effectenTekstueel,
              securitiesCurrentDisclosure: this.securitiesCurrentDisclosureFg.value,
              securitiesCurrentFairValueDisclosure: this.securitiesCurrentFairValueDisclosureFg.value,
              securitiesUnavailableCurrentDescription: this.securitiesUnavailableCurrentDescriptionFg.value,
              securitiesNoLegalOwnershipDescription: this.securitiesNoLegalOwnershipDescriptionFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
  }
}
